import { render, staticRenderFns } from "./SelectFruitType.vue?vue&type=template&id=11ff9465&scoped=true"
import script from "./SelectFruitType.vue?vue&type=script&lang=js"
export * from "./SelectFruitType.vue?vue&type=script&lang=js"
import style0 from "./SelectFruitType.vue?vue&type=style&index=0&id=11ff9465&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ff9465",
  null
  
)

export default component.exports